import { dismissToastMessages, showToast } from 'common/ToastMessage'
import { Props, RateGenerationToast } from 'screens/ProseEdit/components/RateGenerationToast/RateGenerationToast'

export const showRateGenerationToast = (
  { generationId, theme, variant, ...rest }: Omit<Props, 'onClose'>,
  durationInSeconds: number = 10,
) => {
  const dismiss = dismissToastMessages

  showToast(
    <RateGenerationToast generationId={generationId} theme={theme} variant={variant} onClose={dismiss} {...rest} />,
    durationInSeconds,
    String(generationId),
  )

  return dismiss
}
